export const PageLoader = () => (
  <div
    data-testid="page-loader"
    className="min-h-screen bg-slate-950 flex flex-col items-center justify-center gap-4"
    role="status"
    aria-live="polite"
    aria-label="Sayfa yükleniyor"
  >
    <div className="relative w-12 h-12">
      <div className="absolute inset-0 rounded-full border-2 border-slate-800" />
      <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-cyan-400 animate-spin" />
    </div>
    <span className="text-slate-500 text-xs font-mono uppercase tracking-widest">Yükleniyor</span>
  </div>
);

export default PageLoader;
